import { render } from "./Shorten.vue?vue&type=template&id=3db43f2d&scoped=true"
import script from "./Shorten.vue?vue&type=script&lang=js"
export * from "./Shorten.vue?vue&type=script&lang=js"

import "./Shorten.vue?vue&type=style&index=0&id=3db43f2d&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db43f2d"]])

export default __exports__